import type { RouterContext } from '../router'

export default ({ next }: RouterContext) => {
    const authStore = useAuthStore()

    if (authStore.check) {
        return next({ name: 'Dashboard' })
    }

    return next()
}
